import { Modal } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import type { Embodiment } from "@/api";
import { canDeleteShared, canModifyEmbodiment, type MePermissions, type UserRole } from "@/app";
import { HatModalHeader } from "@/components/modal";
import { EmbodimentDetailContent } from "./EmbodimentDetailContent";

export type EmbodimentDetailModalProps = {
  open: boolean;
  embodiment: Embodiment;
  role: UserRole | null;
  // 서버가 계산한 삭제 권한(선택)이다. 전달하지 않으면 등급(admin)으로 폴백한다.
  permissions?: MePermissions | null;
  onClose: () => void;
  // Admin 전용 편집 진입점(선택)이다. 비-admin 이거나 값이 없으면 버튼을 숨긴다. 데이터셋 상세처럼
  // embodiment 정의를 편집할 수 없는 진입점에서는 생략한다. Embodiment 페이지는 이 값을 제공한다.
  onEdit?: () => void;
  // 삭제 진입점(선택)이다. 값이 없으면 삭제 버튼을 숨긴다. 데이터셋 상세처럼 편집만 노출하는
  // 진입점에서 생략한다. Embodiment 페이지는 이 값을 제공한다.
  onDelete?: () => void;
};

// Embodiment 읽기 전용 상세 모달이다. 본문은 공용 EmbodimentDetailContent 가 그린다. 여기서는 모달
// 셸(헤더의 admin edit/delete 액션 포함)만 추가한다. 진입점은 Embodiment 페이지(행 클릭)다.
export function EmbodimentDetailModal({
  open,
  embodiment,
  role,
  permissions,
  onClose,
  onEdit,
  onDelete,
}: EmbodimentDetailModalProps): ReactNode {
  const canModify = canModifyEmbodiment(role);
  // 삭제는 공유 카탈로그 권한(서버 SoT)으로 판정한다. 권한을 전달하지 않으면 등급(admin)으로 폴백한다.
  const canDelete = canDeleteShared(permissions ?? null, role);
  const title = embodiment.name;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="md"
      style={{ maxWidth: "min(92vw, 40rem)" }}
      aria-labelledby="embodiment-detail-title"
    >
      {/* 우상단 액션: admin 만 edit/delete 를 가진다. 값이 없으면 HatModalHeader 가 버튼을 숨기고 읽기 전용을 유지한다. */}
      <HatModalHeader
        title={title}
        titleId="embodiment-detail-title"
        edit={canModify && onEdit ? onEdit : undefined}
        delete={canDelete && onDelete ? onDelete : undefined}
        close
      />
      <EmbodimentDetailContent embodiment={embodiment} />
    </Modal>
  );
}
